export default function extractUrlPath(url: string): string | undefined {
    if (url) {
        const splitParts = url.split('/');
        if (splitParts.length > 3) {
            const pathParts = splitParts.slice(3, splitParts.length);
            return `/${pathParts.join('/')}`;
        }
    }
    return undefined;
}